import { useRef } from 'react';

import cn from 'classnames';

import { IconComponent } from 'components/Icon/IconComponent';
import { IconButton } from 'components/IconButton/IconButton';
import StatusPill from 'components/Pills/StatusPills';

import { useClickOutside } from '../../hooks/click-outside';
import styles from './AnimatedModal.module.scss';

export const AnimatedModal = ({
  visible,
  children,
  className,
  title,
  description,
  icon,
  noClose = false,
  customActions = [],
  onClose = () => {},
  status,
  small = false,
  large = false,
  noPadding = false,
  fullscreen = false,
  actionButtons,
  oldIconLibrary = true,
}) => {
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, onClose);

  return (
    <div className={cn(styles.root, { [styles.rootVisible]: visible })}>
      <div
        className={cn(styles.contentWrapper, noPadding && '!p-0', {
          [styles.contentWrapperSmall]: small,
          [styles.contentWrapperLarge]: large,
          [styles.contentWrapperFullscreen]: fullscreen,
        })}
        ref={wrapperRef}>
        <div
          className={cn(
            styles.header,
            'p-[16px]',
            'd-flex',
            'justify-content-between',
            'align-items-start',
            'border-b',
            'border-neutral-4',
          )}>
          <div className={cn(styles.headerContent, 'flex', 'items-center', 'mr-16')}>
            {icon && (
              <div className="u-margin-right">
                <IconComponent icon={icon} oldIconLibrary={oldIconLibrary} />
              </div>
            )}
            <div className="d-flex flex-column align-items-start">
              <div className={cn('d-flex align-items-center', description ? 'mt-0' : 'mt-2')}>
                {title && (
                  <span className="text-neutral-7 font-medium text-3xl capitalize">{title}</span>
                )}
                {status && (
                  <StatusPill text={status.text} status={status.status} className={styles.status} />
                )}
              </div>
              {description && (
                <p
                  className="u-font-weight-400 secondary-text"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            </div>
          </div>
          <div className="d-flex align-items-center u-gap">
            {(customActions || []).map((action, index) => {
              return (
                <IconButton
                  key={action.text + index}
                  icon={action.icon}
                  onClick={action.onClick}
                  tip={action.text}
                  prefix="hugeicons"
                />
              );
            })}
            {!noClose && <IconButton icon="x" onClick={onClose} tip="Close" placement="bottom" />}
          </div>
        </div>
        <div className={cn(noPadding ? 'p-0' : 'p-[16px]', { [className]: className })}>
          {children}
        </div>
        {actionButtons && <div>{actionButtons}</div>}
      </div>
    </div>
  );
};
